import { DefaultState, IState } from "./state";
import { Keys, Types } from "./actions/types";
import { trainer, emptyTrainer } from '../../../model/trainer';

// const sanifyContact = (c: contact): contact => {
//     let s = emptyContact();
//     Object.keys(c).forEach(key => {
//         if (c[key]) {
//             s[key] = c[key];
//         }
//     })
//     return s;
// }


export const reducer = (state: IState = DefaultState(), action: Types): IState => {
    switch (action.type) {
        case Keys.LOADTRAINERS_PENDING: {
            return {
                ...state,
                trainers: [],
                isLoadingTrainers: true,
            }
        }
        case Keys.LOADTRAINERS_FULFILLED: {
            let p: Array<trainer> = action.payload;
            return {
                ...state,
                trainers: p,
                isLoadingTrainers: false,
            }
        }
        case Keys.LOADTRAINERS_REJECTED: {
            return {
                ...state,
                trainers: [],
                isLoadingTrainers: false,
            }
        }
        case Keys.SAVETRAINER_PENDING: {
            return {
                ...state,
                selectedTrainer: undefined,
                isLoadingTrainer: true,
            }
        }
        case Keys.SAVETRAINER_FULFILLED: {
            let p: trainer = action.payload; // sanifyContact();
            let trainers = [...state.trainers];

            let found = trainers.find(c => c._id === p._id);
            if (!found)
                trainers.push(p);
            return {
                ...state,
                selectedTrainer: p,
                trainers: trainers,
                isLoadingTrainer: false,
            }
        }
        case Keys.SAVETRAINER_REJECTED: {
            return {
                ...state,
                isLoadingTrainer: false,
            }
        }
        case Keys.LOADTRAINER_PENDING: {
            return {
                ...state,
                selectedTrainer: undefined,
                isLoadingTrainer: true,
            }
        }
        case Keys.LOADTRAINER_FULFILLED: {
            let p: trainer = action.payload;
            return {
                ...state,
                selectedTrainer: p,
                isLoadingTrainer: false,
            }
        }
        case Keys.LOADTRAINER_REJECTED: {
            return {
                ...state,
                selectedTrainer: undefined,
                isLoadingTrainer: false,
            }
        }
        case Keys.CREATENEWTRAINER: {
            let p: trainer = emptyTrainer();
            return {
                ...state,
                selectedTrainer: p,
                isLoadingTrainer: false,
            }
        }
        // case Keys.USERCONNECTED: {
        //     const { sub, connId }: { sub: string, connId: string } = action.payload;
        //     let contacts = [...state.contacts];
        //     let found = contacts.find(c => c.sub == sub);
        //     if (found)
        //         found.connectionId = connId;
        //     let recentContacts = [...state.recentContacts];
        //     found = recentContacts.find(c => c.sub == sub);
        //     if (found)
        //         found.connectionId = connId;
        //     return {
        //         ...state,
        //         contacts: contacts,
        //         recentContacts: recentContacts
        //     }
        // }
        // case Keys.USERDISCONNECTED: {
        //     const sub: string = action.payload;
        //     let contacts = [...state.contacts];
        //     let found = contacts.find(c => c.sub == sub);
        //     if (found)
        //         found.connectionId = null;
        //     let recentContacts = [...state.recentContacts];
        //     found = recentContacts.find(c => c.sub == sub);
        //     if (found)
        //         found.connectionId = null;
        //     return {
        //         ...state,
        //         contacts: contacts,
        //         recentContacts: recentContacts
        //     }
        // }
        // case Keys.CLEARSELECTION: {
        //     return {
        //         ...state,
        //         contact: undefined,
        //     }
        // }
        default:
            return state;
    }
}